<div
  class="card-nav-item card-shadow-0 hover-default-shadow active-transparent pointer gp-12 gp-sm-8"
  [routerLink]="url()"
  [fragment]="fragment()"
  routerLinkActive="active"
  (click)="clicked.emit()"
>
  <div class="d-flex align-items-center">
    <i class="mw-100" [ngClass]="icon()"></i>
    <span class="rt2-regular text-ellipsis gpl-12">
      {{ title() | translate }}
    </span>
    @if (isNew()) {
      <span
        class="d-inline-block l2-semibold text-uppercase tag gp-tag gp-tag-red new-analysis text-nowrap gml-12"
      >
        {{ 'RESULTS.MENU.TAG.NEW' | translate }}
      </span>
    }
    @if (isNewAnalyses()) {
      <span
        class="d-inline-block l2-semibold text-uppercase tag gp-tag gp-tag-red new-analysis text-nowrap gml-12"
      >
        {{ 'ANALYSES.NEW.LABEL' | translate }}
      </span>
    }
  </div>
</div>
